
import dayjs from 'dayjs'

import BtnReadmore from '~/components/common/btn-readmore.vue'
import Title from '~/components/specialist/section-title.vue'

export default {
  name: 'SpecialistCulture',
  components: {
    Title,
    BtnReadmore
  },
  props: {
    communityItems: {
      type: Array,
      default: () => []
    },
    kaggleNews: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    blocks() {
      return [
        {
          title: 'AI技術勉強会',
          paragraphs: [
            'GO株式会社・GOドライブ株式会社と共同で開催する、AI技術の勉強会です。最新論文の紹介からKaggleコンペの反省会、生成AI・コンピュータビジョン・因果推論・MLOpsまで、毎週幅広いテーマを扱っています。事業ドメインや会社の枠を越えて知見を共有し合い、社外秘を除く発表資料は積極的に公開しています。'
          ],
          items: this.communityItems.filter(Boolean).map((item) => ({
            date: item.eventDate ? dayjs(item.eventDate).format('YYYY.MM.DD') : '',
            title: item.title || '',
            url: item.url || '',
            external: true
          })),
          readMoreLink: this.$link.communityPage()
        },
        {
          title: 'kaggle社内ランク制度',
          paragraphs: [
            '業務時間を使ってKaggleなどのコンペに参加できる制度です。',
            'Kaggle Grandmaster4名・Master8名・Expert4名（計16名／26年9月時点）が在籍し、国内最多クラスの実践的な環境で技術を磨いています。',
            '直近もNFL Big Data Bowl 2026で5位・金メダル、Santa 2025で2位・金メダルなどの実績があり、その技術は事業の課題解決にも活かされています。GCP費用（月20万円まで）やイベント参加の支援もあります。'
          ],
          items: this.kaggleNews.filter(Boolean).map((item) => ({
            date: item.publishedAtStr || '',
            title: item.title || '',
            url: item.slug ? this.$link.newsDetailPage(item.slug) : '',
            external: false
          })),
          readMoreLink: this.$link.kagglePage()
        }
      ]
    }
  }
}
